export const PROMPT_MODES = {
  AI: 'AI',
  MANUAL: 'MANUAL',
} as const

export const AVAILABLE_OPERATORS = {
  GREATER_THAN: 'greater than',
  LESS_THAN: 'less than',
  IS_BETWEEN: 'is between',
  EQUAL: 'equals',
  NOT_EQUAL: 'does not equal',
  INCLUDES: 'in',
}

export const OPERATORS_LIST = Object.values(AVAILABLE_OPERATORS).map((v) => ({
  label: v,
  value: v,
}))

export const CONFIRMATION_TEXT_COPIES = {
  [PROMPT_MODES.AI]: 'Confirm changes',
  [PROMPT_MODES.MANUAL]: 'Update qualification rules?',
  singular: {
    description: 'We noticed you made a change to the found attribute.',
    note: 'Note: By continuing, we’ll update your original description to reflect this change.',
  },
  plural: {
    description: 'We noticed you made some changes to the found attributes.',
    note: 'Note: By continuing, we’ll update your original description to reflect these changes.',
  },
}

export const QUALIFICATION_DEFAULT_NAME = 'Edit persona description'
